import React from 'react';
import axios from 'axios';
import {Route} from 'react-router-dom';
import { Redirect } from 'react-router';
import {Context} from "../configcontext/ConfigContext";
import DatePicker from 'react-datepicker';
import LoadingSpinner from '../loadingspinner/LoadingSpinner';
import EsriKMLMap from '../esrikmlmap/EsriKMLMap';
import { Modal, Button } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import FeatureServiceWrapperKML from "../featureservicewrapperkml/FeatureServiceWrapperKML";
import 'react-datepicker/dist/react-datepicker.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './KMLProject2.css';

class KMLProject2 extends React.Component{

    static contextType = Context;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            projectName: "",
            projectDescription: "",
            projectCountry: "",
            projectCity: "",
            projectState: "",
            startDate: new Date(),
            endDate: new Date(),
            features: [],
            mappingConstant: [{"feature_service_type_id":8,"feature_layers":[{"feature_layer_type_id":29,"feature_name":"territory"}]},{"feature_service_type_id":1,"feature_layers":[{"feature_layer_type_id":1,"feature_name":"watermain"},{"feature_layer_type_id":2,"feature_name":"waterservice"},{"feature_layer_type_id":3,"feature_name":"waterhydrant"},{"feature_layer_type_id":4,"feature_name":"waterservicevalve"},{"feature_layer_type_id":5,"feature_name":"watermainvalve"},{"feature_layer_type_id":35,"feature_name":"watermainfitting"},{"feature_layer_type_id":36,"feature_name":"waterservicefitting"}]},{"feature_service_type_id":2,"feature_layers":[{"feature_layer_type_id":6,"feature_name":"electricprimaryoverhead"},{"feature_layer_type_id":7,"feature_name":"electricprimaryunderground"},{"feature_layer_type_id":8,"feature_name":"electricpole"},{"feature_layer_type_id":9,"feature_name":"electrictransformer"},{"feature_layer_type_id":10,"feature_name":"electricmanhole"},{"feature_layer_type_id":30,"feature_name":"electricsecondaryunderground"},{"feature_layer_type_id":31,"feature_name":"electricsecondaryoverhead"},{"feature_layer_type_id":32,"feature_name":"electricserviceunderground"},{"feature_layer_type_id":33,"feature_name":"electricserviceoverhead"},{"feature_layer_type_id":34,"feature_name":"electricpoletransformer"}]},{"feature_service_type_id":3,"feature_layers":[{"feature_layer_type_id":11,"feature_name":"gasmain"},{"feature_layer_type_id":12,"feature_name":"gasservice"},{"feature_layer_type_id":13,"feature_name":"gasmainvalve"},{"feature_layer_type_id":14,"feature_name":"gasservicevalve"}]},{"feature_service_type_id":4,"feature_layers":[{"feature_layer_type_id":15,"feature_name":"stormmain"},{"feature_layer_type_id":16,"feature_name":"stormservice"},{"feature_layer_type_id":17,"feature_name":"stormcatchbasin"},{"feature_layer_type_id":18,"feature_name":"stormmanhole"}]},{"feature_service_type_id":5,"feature_layers":[{"feature_layer_type_id":19,"feature_name":"fiberprimaryunderground"},{"feature_layer_type_id":20,"feature_name":"fiberprimaryoverhead"},{"feature_layer_type_id":21,"feature_name":"fibermanhole"}]},{"feature_service_type_id":6,"feature_layers":[{"feature_layer_type_id":22,"feature_name":"telecomunderground"},{"feature_layer_type_id":23,"feature_name":"telecomoverhead"},{"feature_layer_type_id":24,"feature_name":"telecommanhole"}]},{"feature_service_type_id":7,"feature_layers":[{"feature_layer_type_id":25,"feature_name":"sanitarymain"},{"feature_layer_type_id":26,"feature_name":"sanitaryservice"},{"feature_layer_type_id":27, "feature_name":"sanitarymanhole"}]},{"feature_service_type_id":9,"feature_layers":[{"feature_layer_type_id":37,"feature_name":"steammain"},{"feature_layer_type_id":38,"feature_name":"steamanchor"},{"feature_layer_type_id":39,"feature_name":"steamexpansionjoint"},{"feature_layer_type_id":40,"feature_name":"steamfitting"},{"feature_layer_type_id":41,"feature_name":"steamcontrolvalve"},{"feature_layer_type_id":43,"feature_name":"steamvault"},{"feature_layer_type_id":44,"feature_name":"steamservice"}]}],
            mapping: [],
            mappingOriginal: [],
            xml: [],
            xmlString: [],
            pathLayers: [],
            multiPathLayers: [],
            pointLayers: [],
            polygonLayers: [],
            show: false,
            modalBody: "",
            modalHeader: "",
            mappingNew: [],
            waterDropdown: false,
            electricDropdown: false,
            gasDropdown: false,
            sanitaryDropdown: false,
            stormDropdown: false,
            fiberDropdown: false,
            telecomDropdown: false,
            steamDropdown: false,
            territoryFeatureLayer: "",
            territoryFeatureLayers: [],
            watermainFeatureLayer: "",
            watermainFeatureLayers: [],
            watermainField: "",
            watermainFields: [],
            waterserviceFeatureLayer: "",
            waterserviceFeatureLayers: [],
            waterserviceField: "",
            waterserviceFields: [],
            watermainvalveFeatureLayer: "",
            watermainvalveFeatureLayers: [],
            watermainvalveField: "",
            watermainvalveFields: [],
            waterservicevalveFeatureLayer: "",
            waterservicevalveFeatureLayers: [],
            waterservicevalveField: "",
            waterservicevalveFields: [],
            waterhydrantFeatureLayer: "",
            waterhydrantFeatureLayers: [],
            waterhydrantField: "",
            waterhydrantFields: [],
            watermainfittingFeatureLayer: "",
            watermainfittingFeatureLayers: [],
            watermainfittingField: "",
            watermainfittingFields: [],
            waterservicefittingFeatureLayer: "",
            waterservicefittingFeatureLayers: [],
            waterservicefittingField: "",
            waterservicefittingFields: [],
            electricprimaryoverheadFeatureLayer: "",
            electricprimaryoverheadFeatureLayers: [],
            electricprimaryoverheadField: "",
            electricprimaryoverheadFields: [],
            electricprimaryundergroundFeatureLayer: "",
            electricprimaryundergroundFeatureLayers: [],
            electricprimaryundergroundField: "",
            electricprimaryundergroundFields: [],
            electricsecondaryoverheadFeatureLayer: "",
            electricsecondaryoverheadFeatureLayers: [],
            electricsecondaryoverheadField: "",
            electricsecondaryoverheadFields: [],
            electricsecondaryundergroundFeatureLayer: "",
            electricsecondaryundergroundFeatureLayers: [],
            electricsecondaryundergroundField: "",
            electricsecondaryundergroundFields: [],
            electricserviceoverheadFeatureLayer: "",
            electricserviceoverheadFeatureLayers: [],
            electricserviceoverheadField: "",
            electricserviceoverheadFields: [],
            electricserviceundergroundFeatureLayer: "",
            electricserviceundergroundFeatureLayers: [],
            electricserviceundergroundField: "",
            electricserviceundergroundFields: [],
            electricpoleFeatureLayer: "",
            electricpoleFeatureLayers: [],
            electricpoleField: "",
            electricpoleFields: [],
            electrictransformerFeatureLayer: "",
            electrictransformerFeatureLayers: [],
            electrictransformerField: "",
            electrictransformerFields: [],
            electricpoletransformerFeatureLayer: "",
            electricpoletransformerFeatureLayers: [],
            electricpoletransformerField: "",
            electricpoletransformerFields: [],
            electricmanholeFeatureLayer: "",
            electricmanholeFeatureLayers: [],
            electricmanholeField: "",
            electricmanholeFields: [],
            gasmainFeatureLayer: "",
            gasmainFeatureLayers: [],
            gasmainField: "",
            gasmainFields: [],
            gasserviceFeatureLayer: "",
            gasserviceFeatureLayers: [],
            gasserviceField: "",
            gasserviceFields: [],
            gasservicevalveFeatureLayer: "",
            gasservicevalveFeatureLayers: [],
            gasservicevalveField: "",
            gasservicevalveFields: [],
            gasmainvalveFeatureLayer: "",
            gasmainvalveFeatureLayers: [],
            gasmainvalveField: "",
            gasmainvalveFields: [],
            sanitarymainFeatureLayer: "",
            sanitarymainFeatureLayers: [],
            sanitarymainField: "",
            sanitarymainFields: [],
            sanitaryserviceFeatureLayer: "",
            sanitaryserviceFeatureLayers: [],
            sanitaryserviceField: "",
            sanitaryserviceFields: [],
            sanitarymanholeFeatureLayer: "",
            sanitarymanholeFeatureLayers: [],
            sanitarymanholeField: "",
            sanitarymanholeFields: [],
            sanitarycatchbasinFeatureLayer: "",
            sanitarycatchbasinFeatureLayers: [],
            sanitarycatchbasinField: "",
            sanitarycatchbasinFields: [],
            stormmainFeatureLayer: "",
            stormmainFeatureLayers: [],
            stormmainField: "",
            stormmainFields: [],
            stormserviceFeatureLayer: "",
            stormserviceFeatureLayers: [],
            stormserviceField: "",
            stormserviceFields: [],
            stormcatchbasinFeatureLayer: "",
            stormcatchbasinFeatureLayers: [],
            stormcatchbasinField: "",
            stormcatchbasinFields: [],
            stormmanholeFeatureLayer: "",
            stormmanholeFeatureLayers: [],
            stormmanholeField: "",
            stormmanholeFields: [],
            fiberprimaryundergroundFeatureLayer: "",
            fiberprimaryundergroundFeatureLayers: [],
            fiberprimaryundergroundField: "",
            fiberprimaryundergroundFields: [],
            fiberprimaryoverheadFeatureLayer: "",
            fiberprimaryoverheadFeatureLayers: [],
            fiberprimaryoverheadField: "",
            fiberprimaryoverheadFields: [],
            fibermanholeFeatureLayer: "",
            fibermanholeFeatureLayers: [],
            fibermanholeField: "",
            fibermanholeFields: [],
            telecomundergroundFeatureLayer: "",
            telecomundergroundFeatureLayers: [],
            telecomundergroundField: "",
            telecomundergroundFields: [],
            telecomoverheadFeatureLayer: "",
            telecomoverheadFeatureLayers: [],
            telecomoverheadField: "",
            telecomoverheadFields: [],
            telecommanholeFeatureLayer: "",
            telecommanholeFeatureLayers: [],
            telecommanholeField: "",
            telecommanholeFields: [],
            steammainFeatureLayer: "",
            steammainFeatureLayers: [],
            steammainField: "",
            steammainFields: [],
            steamserviceFeatureLayer: "",
            steamserviceFeatureLayers: [],
            steamserviceField: "",
            steamserviceFields: [],
            steamanchorFeatureLayer: "",
            steamanchorFeatureLayers: [],
            steamanchorField: "",
            steamanchorFields: [],
            steamexpansionjointFeatureLayer: "",
            steamexpansionjointFeatureLayers: [],
            steamexpansionjointField: "",
            steamexpansionjointFields: [],
            steamfittingFeatureLayer: "",
            steamfittingFeatureLayers: [],
            steamfittingField: "",
            steamfittingFields: [],
            steamcontrolvalveFeatureLayer: "",
            steamcontrolvalveFeatureLayers: [],
            steamcontrolvalveField: "",
            steamcontrolvalveFields: [],
            steamvaultFeatureLayer: "",
            steamvaultFeatureLayers: [],
            steamvaultField: "",
            steamvaultFields: []
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleDropdown = this.handleDropdown.bind(this);
        this.featureLayerChange = this.featureLayerChange.bind(this);
        this.fieldChange = this.fieldChange.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.fileUploaded = this.fileUploaded.bind(this);
        this.parseTextAsXml = this.parseTextAsXml.bind(this);
        this.xmlToJson = this.xmlToJson.bind(this);
        this.kmlRef = React.createRef();
        this.addFeatureLayer = this.addFeatureLayer.bind(this);
        this.updateFeatureLayer = this.updateFeatureLayer.bind(this);
        this.deleteLayer = this.deleteLayer.bind(this);
    }

    deleteLayer(feature_layer_map_index){
        //console.log(feature_layer_map_index);
        var mappingNewCopy = JSON.parse(JSON.stringify(this.state.mappingNew));
        var numMapping = mappingNewCopy.length;
        for (var i2 = 0; i2 < numMapping; i2++) {
            var numLayers = mappingNewCopy[i2].feature_layers.length;
            var isMatch = false;
            var matchIndex;
            var numFeatureLayers;
            var feature_layer_type_id;
            var feature_layer_mapped_id;
            for (var i3 = 0; i3 < numLayers; i3++) {
                if (mappingNewCopy[i2].feature_layers[i3].feature_layer_map_index == feature_layer_map_index) {
                    isMatch = true;
                    matchIndex = i3;
                    feature_layer_type_id = mappingNewCopy[i2].feature_layers[i3].feature_layer_type_id;
                }
            }
            if(isMatch){
                //console.log("Here");
                var num_feature_layers = 0;
                for(var i3 = 0; i3 < mappingNewCopy[i2].feature_layers.length; i3++){
                    if(mappingNewCopy[i2].feature_layers[i3].feature_layer_type_id == feature_layer_type_id){
                        num_feature_layers = num_feature_layers + 1;
                        //console.log("Here");
                    }
                }
                if(num_feature_layers > 1){
                    mappingNewCopy[i2].feature_layers.splice(matchIndex,1);
                    break;
                }else{
                    const featureLayerCopy = JSON.parse(JSON.stringify(mappingNewCopy[i2].feature_layers[matchIndex]));
                    featureLayerCopy["feature_layer_mapped_id"] = "";
                    featureLayerCopy["feature_layer_name"] = "";
                    featureLayerCopy["feature_service_name"] = "";
                    featureLayerCopy["feature_layer_url"] = "";
                    featureLayerCopy["attributes"] = [];
                    featureLayerCopy["feature_layer_mapped_fields"] = [];
                    featureLayerCopy["shapefile"] = false;
                    featureLayerCopy["sorting_index"] = 1;
                    var length = 4;
                    var result = '';
                    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                    var charactersLength = characters.length;
                    for ( var i4 = 0; i4 < length; i4++ ) {
                      result += characters.charAt(Math.floor(Math.random() * charactersLength));
                    }
                    featureLayerCopy["feature_layer_map_index"] = result;
                    mappingNewCopy[i2].feature_layers.splice(matchIndex,1);
                    mappingNewCopy[i2].feature_layers.push(featureLayerCopy);
                    break;
                }
            }
        }
        var featuresArray = JSON.parse(JSON.stringify(this.state.features));
        var numFeatures = featuresArray.length;
        //console.log(featuresArray);
        for(var i=numFeatures-1; i >= 0; i--){
            if(featuresArray[i]["feature_layer_map_index"] == feature_layer_map_index){
                featuresArray.splice(i,1);
                //console.log("Here");
            }
        }
        //console.log(inactiveArrayCopy);
        this.setState({mappingNew: mappingNewCopy, features: featuresArray});
        //console.log(this.state);
    }

    updateFeatureLayer(feature_layer_name, feature_layer_map_index){
        //console.log(feature_layer_name + " " + feature_layer_map_index);
        var mappingNew = JSON.parse(JSON.stringify(this.state.mappingNew));
        var numServices = mappingNew.length;
        for(var i = 0; i < numServices; i++){
            if(mappingNew[i].feature_layers){
                var numLayers = mappingNew[i].feature_layers.length;
                for(var i2 = 0; i2 < numLayers; i2++){
                    if(mappingNew[i].feature_layers[i2]["feature_layer_map_index"] == feature_layer_map_index){
                        //console.log("Here, feature layer map index matches");
                        mappingNew[i].feature_layers[i2].feature_layer_name = feature_layer_name;
                    }
                }
            }
        }
        this.setState({mappingNew: mappingNew}, this.featureLayerChange(feature_layer_map_index, feature_layer_name));
    }

    addFeatureLayer(feature_layer_map_index){
        //console.log(feature_layer_map_index);
        var mappingNewCopy = JSON.parse(JSON.stringify(this.state.mappingNew));
        //console.log(this.state.mappingNew);
        //console.log(JSON.parse(JSON.stringify(mappingNewCopy)));
        var numMapping = mappingNewCopy.length;
        for (var i2 = 0; i2 < numMapping; i2++) {
            var numLayers = mappingNewCopy[i2].feature_layers.length;
            var isMatch = false;
            var matchIndex;
            var sortingIndex = 0;
            for (var i3 = 0; i3 < numLayers; i3++) {
                if (mappingNewCopy[i2].feature_layers[i3].feature_layer_map_index == feature_layer_map_index) {
                    //console.log(JSON.parse(JSON.stringify(mappingNewCopy[i2].feature_layers[i3].feature_layer_map_index)));
                    //console.log(i3);
                    //console.log(JSON.parse(JSON.stringify(mappingNewCopy[i2].feature_layers)));
                    //console.log(JSON.parse(JSON.stringify(mappingNewCopy[i2].feature_layers[i3])));
                    isMatch = true;
                    matchIndex = i3;
                }
            }
            if(isMatch){
                for(var i3 = 0; i3 < mappingNewCopy[i2].feature_layers.length; i3++){
                    if(mappingNewCopy[i2].feature_layers[i3].sorting_index > sortingIndex){
                        sortingIndex = mappingNewCopy[i2].feature_layers[i3].sorting_index;
                        //console.log("Sorting Index = " + sortingIndex);
                    }
                }
                //Have to do this to create a deep clone of the array so it doesn't update state
                const featureLayerCopy = JSON.parse(JSON.stringify(mappingNewCopy[i2].feature_layers[matchIndex]));
                featureLayerCopy["feature_layer_mapped_id"] = "";
                featureLayerCopy["feature_layer_name"] = "";
                featureLayerCopy["feature_service_name"] = "";
                featureLayerCopy["feature_layer_url"] = "";
                featureLayerCopy["attributes"] = [];
                featureLayerCopy["feature_layer_mapped_fields"] = [];
                featureLayerCopy["shapefile"] = false;
                featureLayerCopy["sorting_index"] = sortingIndex + 1;
                var length = 4;
                var result = '';
                var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                var charactersLength = characters.length;
                for ( var i4 = 0; i4 < length; i4++ ) {
                  result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                featureLayerCopy["feature_layer_map_index"] = result;
                //console.log(featureLayerCopy);
                mappingNewCopy[i2].feature_layers.push(featureLayerCopy);
            }
        }
        //console.log(JSON.parse(JSON.stringify(mappingNewCopy)));
        this.setState({mappingNew: mappingNewCopy});
    }

    handleDropdown(e){
        var elementName = e.target.id + "Wrapper";
        let element = document.getElementById(elementName);
        if(this.state[e.target.id] == false){
          ReactDOM.findDOMNode(element).style.display = "block";
          this.setState({[e.target.id]: true});
        }else{
          ReactDOM.findDOMNode(element).style.display = "none";
          this.setState({[e.target.id]: false});
        }
    }

    parseTextAsXml(text){
        var parser = new DOMParser();
        var xmlDom = parser.parseFromString(text, "text/xml");
        var xmlJson = this.xmlToJson(xmlDom);
        var totalMessages = Object.keys(xmlJson.kml.Document.Folder.Placemark).length;
        var pathLayers = [""];
        var pointLayers = [""];
        var polygonLayers = [""];
        var multiPathLayers = [];
        for (var i = 0; i < totalMessages; i++){
            if(xmlJson.kml.Document.Folder.Placemark[i].ExtendedData){
                if(xmlJson.kml.Document.Folder.Placemark[i].ExtendedData.SchemaData){
                    if(xmlJson.kml.Document.Folder.Placemark[i].ExtendedData.SchemaData.SimpleData["#text"]){
                        var layerName = xmlJson.kml.Document.Folder.Placemark[i].ExtendedData.SchemaData.SimpleData["#text"];
                    }else if(xmlJson.kml.Document.Folder.Placemark[i].ExtendedData.SchemaData["@attributes"]){
                        if(xmlJson.kml.Document.Folder.Placemark[i].ExtendedData.SchemaData["@attributes"].schemaUrl){
                            var layerName = xmlJson.kml.Document.Folder.Placemark[i].ExtendedData.SchemaData["@attributes"].schemaUrl;
                        }
                    }else if(xmlJson.kml.Document.Folder.Placemark[i].name){
                        var layerName = xmlJson.kml.Document.Folder.Placemark[i].name["#text"]; 
                        //console.log(layerName);
                    }
                }else if(xmlJson.kml.Document.Folder.Placemark[i].name){
                    var layerName = xmlJson.kml.Document.Folder.Placemark[i].name["#text"]; 
                    //console.log(layerName);
                }
            }else if(xmlJson.kml.Document.Folder.Placemark[i].name){
                var layerName = xmlJson.kml.Document.Folder.Placemark[i].name["#text"];
            }
          if ('LineString' in xmlJson.kml.Document.Folder.Placemark[i]){
            if(pathLayers.includes(layerName)){
              //Do nothing
            }else{
              pathLayers.push(layerName);
            }
          }
          if ('Polygon' in xmlJson.kml.Document.Folder.Placemark[i]){
            if(polygonLayers.includes(layerName)){
              //Do nothing
            }else{
              polygonLayers.push(layerName);
            }
          }
          if ('Point' in xmlJson.kml.Document.Folder.Placemark[i]){
            if(pointLayers.includes(layerName)){
              //Do nothing
            }else{
              pointLayers.push(layerName);
            }
          }
          if('MultiGeometry' in xmlJson.kml.Document.Folder.Placemark[i]){
            if('LineString' in xmlJson.kml.Document.Folder.Placemark[i].MultiGeometry){
                if(multiPathLayers.includes(layerName)){
                  //Do nothing
                }else{
                  multiPathLayers.push(layerName);
                }
            }
          }
        }
        this.setState({pathLayers: pathLayers, multiPathLayers: multiPathLayers, pointLayers: pointLayers, polygonLayers: polygonLayers, xml: xmlJson});
    }

    fileUploaded(event) {
        var parent = this;
        var file = event.target.files[0];
        var reader = new FileReader();
        reader.onloadend = function(event) {
          parent.parseTextAsXml(event.target.result);
          parent.setState({xmlString: event.target.result});
        };
        reader.readAsText(file);
    }

    // Changes XML to JSON
    xmlToJson(xml) {
        // Create the return object
        var obj = {};
        if (xml.nodeType == 1) { // element
            // do attributes
            if (xml.attributes.length > 0) {
            obj["@attributes"] = {};
                for (var j = 0; j < xml.attributes.length; j++) {
                    var attribute = xml.attributes.item(j);
                    obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
                }
            }
        } else if (xml.nodeType == 3) { // text
          obj = xml.nodeValue;
        }

        // do children
        if (xml.hasChildNodes()) {
            for(var i = 0; i < xml.childNodes.length; i++) {
                var item = xml.childNodes.item(i);
                var nodeName = item.nodeName;
                if (typeof(obj[nodeName]) == "undefined") {
                    obj[nodeName] = this.xmlToJson(item);
                } else {
                    if (typeof(obj[nodeName].push) == "undefined") {
                        var old = obj[nodeName];
                        obj[nodeName] = [];
                        obj[nodeName].push(old);
                    }
                    obj[nodeName].push(this.xmlToJson(item));
                }
            }
        }
        return obj;
    }   

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    handleStartDateChange(date) {
        this.setState({startDate: date});
    }

    handleEndDateChange(date) {
        this.setState({endDate: date});
    }

    featureLayerChange(feature_layer_map_index, feature_layer_name){
        var feature_service_type;
        var feature_layer_type_id;
        var feature_layer_type;
        var feature_type;
        var feature_service_type_id;
        var mappingNew = JSON.parse(JSON.stringify(this.state.mappingNew));
        var numServices = mappingNew.length;
        //console.log(mappingNew);
        for(var i = 0; i < numServices; i++){
            if(mappingNew[i].feature_layers){
                var numLayers = mappingNew[i].feature_layers.length;
                for(var i2 = 0; i2 < numLayers; i2++){
                    if(mappingNew[i].feature_layers[i2]["feature_layer_map_index"] == feature_layer_map_index){
                        //console.log("Here, feature layer map index matches");
                        //mappingNew[i].feature_layers[i2].feature_layer_name = feature_layer_name;
                        feature_layer_type_id = mappingNew[i].feature_layers[i2]["feature_layer_type_id"];
                        feature_layer_type = mappingNew[i].feature_layers[i2]["label"];
                        feature_type = mappingNew[i].feature_layers[i2]["feature_type"];
                        feature_service_type_id = mappingNew[i]["feature_service_type_id"];
                        feature_service_type = mappingNew[i]["name"];
                    }
                }
            }
        }
        var featuresArray = JSON.parse(JSON.stringify(this.state.features));
        var numFeatures = featuresArray.length;
        //console.log(featuresArray);
        if(numFeatures > 0){
            for(var i=numFeatures-1; i >= 0; i--){
                if(featuresArray[i]["feature_layer_map_index"] == feature_layer_map_index){
                    featuresArray.splice(i,1);
                    //console.log("Here");
                }
            }
        }
        var numPlacemarks = this.state.xml.kml.Document.Folder.Placemark.length;
        for(var i=0; i<numPlacemarks; i++){
            if(this.state.xml.kml.Document.Folder.Placemark[i].ExtendedData){
                if(this.state.xml.kml.Document.Folder.Placemark[i].ExtendedData.SchemaData){
                    if(this.state.xml.kml.Document.Folder.Placemark[i].ExtendedData.SchemaData.SimpleData["#text"]){
                        var currentLayer = this.state.xml.kml.Document.Folder.Placemark[i].ExtendedData.SchemaData.SimpleData["#text"];
                    }else if(this.state.xml.kml.Document.Folder.Placemark[i].ExtendedData.SchemaData["@attributes"]){
                        if(this.state.xml.kml.Document.Folder.Placemark[i].ExtendedData.SchemaData["@attributes"].schemaUrl){
                            var currentLayer = this.state.xml.kml.Document.Folder.Placemark[i].ExtendedData.SchemaData["@attributes"].schemaUrl;
                        }
                    }else if(this.state.xml.kml.Document.Folder.Placemark[i].name){
                        var currentLayer = this.state.xml.kml.Document.Folder.Placemark[i].name["#text"]; 
                        //console.log(currentLayer);
                    }
                }else if(this.state.xml.kml.Document.Folder.Placemark[i].name){
                    var currentLayer = this.state.xml.kml.Document.Folder.Placemark[i].name["#text"]; 
                    //console.log(currentLayer);
                }
            }else if(this.state.xml.kml.Document.Folder.Placemark[i].name){
                var currentLayer = this.state.xml.kml.Document.Folder.Placemark[i].name["#text"];
            }
            /*if(this.state.xml.kml.Document.Folder.Placemark[i].ExtendedData){
                if(this.state.xml.kml.Document.Folder.Placemark[i].ExtendedData.SchemaData.SimpleData["#text"]){
                    var currentLayer = this.state.xml.kml.Document.Folder.Placemark[i].ExtendedData.SchemaData.SimpleData["#text"];
                }else{
                    var currentLayer = this.state.xml.kml.Document.Folder.Placemark[i].ExtendedData.SchemaData["@attributes"].schemaUrl;
                }
            }else if(this.state.xml.kml.Document.Folder.Placemark[i].name){
                var currentLayer = this.state.xml.kml.Document.Folder.Placemark[i].name["#text"];
            }*/
            //var currentLayer = this.state.xml.kml.Document.Folder.Placemark[i].ExtendedData.SchemaData.SimpleData["#text"];
            if(currentLayer == feature_layer_name){
                if(this.state.xml.kml.Document.Folder.Placemark[i].LineString){
                    var pathArray = this.state.xml.kml.Document.Folder.Placemark[i].LineString.coordinates["#text"].split(" ");
                    //console.log("Path Array: " + pathArray);
                    var numPaths = pathArray.length;
                    var singlePath = [];
                    for(var i2=0; i2<numPaths; i2++){
                        var pathText = pathArray[i2].replace(/\s/g, '');
                        if(pathText != " " && pathText != ""){
                            var singlePathArray = pathText.split(",");
                            var longitude = singlePathArray[0];
                            var latitude = singlePathArray[1];
                            var path = {longitude, latitude};
                            singlePath.push(path);
                        }
                    }
                    featuresArray.push({"feature_service_type": feature_service_type, "feature_service_type_id": feature_service_type_id, "feature_type": feature_type, "feature_layer_type": feature_layer_type, "feature_layer_type_id": feature_layer_type_id, "paths": singlePath, "feature_layer_map_index": feature_layer_map_index});
                }else if(this.state.xml.kml.Document.Folder.Placemark[i].Polygon){
                }else if(this.state.xml.kml.Document.Folder.Placemark[i].Point){
                    var pointArray = this.state.xml.kml.Document.Folder.Placemark[i].Point.coordinates["#text"];
                    var singlePointArray = pointArray.split(",");
                    var longitude = singlePointArray[0];
                    var latitude = singlePointArray[1];
                    var point = {longitude, latitude};
                    featuresArray.push({"feature_service_type": feature_service_type, "feature_service_type_id": feature_service_type_id, "feature_type": feature_type, "feature_layer_type": feature_layer_type, "feature_layer_type_id": feature_layer_type_id, "points": point, "feature_layer_map_index": feature_layer_map_index});
                }else if(this.state.xml.kml.Document.Folder.Placemark[i].MultiGeometry){
                    if(this.state.xml.kml.Document.Folder.Placemark[i].MultiGeometry.LineString){
                        var pathArray = this.state.xml.kml.Document.Folder.Placemark[i].MultiGeometry.LineString.coordinates["#text"].split(" ");
                        //console.log("Path Array: " + pathArray);
                        var numPaths = pathArray.length;
                        var singlePath = [];
                        for(var i2=0; i2<numPaths; i2++){
                            var pathText = pathArray[i2].replace(/\s/g, '');
                            if(pathText != " " && pathText != ""){
                                var singlePathArray = pathArray[i2].split(",");
                                var longitude = singlePathArray[0];
                                var latitude = singlePathArray[1];
                                var path = {longitude, latitude};
                                singlePath.push(path);
                            }
                        }
                        featuresArray.push({"feature_service_type": feature_service_type, "feature_service_type_id": feature_service_type_id, "feature_type": feature_type, "feature_layer_type": feature_layer_type, "feature_layer_type_id": feature_layer_type_id, "paths": singlePath, "feature_layer_map_index": feature_layer_map_index});
                    }
                }
            }
        }
        this.setState({features: featuresArray});
    }

    fieldChange(e){
        var fieldName = e.target.id + "Field";
        this.setState({[fieldName]: e.target.value});
    }

    handleSubmit(){
        let value = this.context;
        this.setState({loading: true});
        if(this.state.projectName != "" && this.state.projectCity != "" && this.state.projectCountry != "" && this.state.projectState != "" && this.state.startDate != "" && this.state.endDate != "" && this.state.projectDescription != ""){
          //axios.post('https://www.arutility.com/api/v3/users/login.php',{username: this.state.username,password:this.state.password})
          //console.log(this.state);
          axios.post('https://www.arutility.com/api/v4/project/createkml.php',{project_name:this.state.projectName, project_city:this.state.projectCity, project_country: this.state.projectCountry, project_state:this.state.projectState, start_date:this.state.startDate, end_date:this.state.endDate, project_description: this.state.projectDescription, features: this.state.features},{headers: {Authorization: 'Bearer ' + value.jwt}})       
            .then(res => {
                this.setState({loading: false, modalBody: "Project successfully created.", modalHeader: "Success", show: true});
            }).catch(error => {
              if (error.response) {
                  this.setState({loading: false, modalBody: error.response.data.error, modalHeader: "Error", show: true});
              } else if (error.request) {
                // The request was made but no response was received
                  this.setState({loading: false, modalBody: "Sorry, there was an error. " + error.request, modalHeader: "Error", show: true});
              } else {
                // Something happened in setting up the request that triggered an Error
                  this.setState({loading: false, modalBody: "Sorry, there was an error. " + error.message, modalHeader: "Error", show: true});
              }
            });
        }else{
          this.setState({loading: false, modalBody: "Sorry, it appears you are missing required information", modalHeader: "Error", show: true});
        }
    }

    showModal(){
        this.setState({show: true});
    }

    closeModal(){
        this.setState({show: false});
    }

    componentDidMount() {
        let value = this.context;
        axios.post('https://www.arutility.com/api/v5/esri/featureService/readAll.php', {}, { headers: { Authorization: 'Bearer ' + value.jwt } }).then(res => {
            this.setState({mappingOriginal: res.data.message});
            var mappingNew = JSON.parse(JSON.stringify(res.data.message));
            //console.log(mappingNew);
            var numServices = mappingNew.length;
            //console.log(numServices);
            for(var i = 0; i < numServices; i++){
                var numLayers = mappingNew[i].feature_layers.length;
                //console.log(numLayers);
                //console.log(mappingNew);
                for(var i2 = 0; i2 < numLayers; i2++){
                    var layerCopy = JSON.parse(JSON.stringify(mappingNew[i].feature_layers[i2]));
                    //console.log(layerCopy);
                    //GENERATE RANDOM ID
                    var length = 4;
                    var result = '';
                    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                    var charactersLength = characters.length;
                    for ( var i3 = 0; i3 < length; i3++ ) {
                      result += characters.charAt(Math.floor(Math.random() * charactersLength));
                    }
                    layerCopy["feature_layer_map_index"] = result;
                    layerCopy["feature_layer_mapped_id"] = "";
                    layerCopy["feature_layer_name"] = "";
                    layerCopy["feature_service_name"] = "";
                    layerCopy["feature_layer_url"] = "";
                    layerCopy["feature_layer_mapped_fields"] = [];
                    layerCopy["attributes"] = [];
                    layerCopy["shapefile"] = false;
                    layerCopy["sorting_index"] = i2;
                    mappingNew[i].feature_layers[i2] = layerCopy;
                }
            }
            //console.log(mappingNew);
            this.setState({mappingNew: mappingNew, loading: false});
            //NOW ASSIGN A RANDOM ID TO EACH LAYER SO WE CAN UPDATE, DELETE AND ADD NEW LAYERS FROM EACH INDIVIDUAL FEATURE LAYER COMPONENT
        }).catch(error => {
            if (error.response) {
                if (error.response.status == 401) {
                    this.setState({ modalBody: "Sorry there was an error: " + error.response.data.message, modalHeader: "Error", show: true, loading: false });
                } else {
                    this.setState({ modalBody: "Sorry, we were unable to retrieve your feature services and feature layers from your GIS. Please try again.", modalHeader: "Error", show: true, loading: false });
                }
            } else if (error) {
                this.setState({ modalBody: "Sorry there was an error: " + error.message, modalHeader: "Error", show: true, loading: false })
            } else {
                this.setState({ modalBody: "Sorry there was an error: " + error, modalHeader: "Error", show: true, loading: false })
            }
        });
    }

    render(){
        let value = this.context;
        var parent = this;
        const {loading, authorized, show, setShow} = this.state;
        if(value.jwt == ""){
          return(
            <Route>
              <Redirect to="/login" />
            </Route>
          );
        }else{
          if(value.userPermissions.includes("project:create")){
              return (
                <div className="createProjectInfoWrapper">
                  {this.state.loading &&
                    <LoadingSpinner />
                  }
                  <Modal show={show} onHide={this.closeModal}>
                    <Modal.Header closeButton>
                      <Modal.Title>{this.state.modalHeader}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{this.state.modalBody}</Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={this.closeModal}>
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <div className="kmluploadwrapper">
                    <form id="uploadKMLProject" encType="multipart/form-data">
                      Drag & drop files here...
                      <br/>
                      <br/>
                      Or browse files to convert
                      <br/>
                      <br/>
                      <input id="kmlprojectfile" ref={this.kmlRef} name="file" className="kmlFileInput" type="file" onChange={this.fileUploaded}/>
                    </form>
                  </div>
                  <b>Project Name:</b>
                  <br/>
                  <input type="text" placeholder="e.g. Main St Utility Replacement" className="projectInputField" name="projectName" id="projectName" required="" onChange={this.handleChange} value={this.state.projectName}/>
                  <br/>
                  <b>Project Description:</b>
                  <br/>
                  <textarea placeholder="e.g. Main St Utility Replacement" className="projectInputArea" name="projectDescription" id="projectDescription" required="" onChange={this.handleChange} value={this.state.projectDescription}></textarea>
                  <br/>
                  <b>Project Country:</b>
                  <br/>
                  <select className="projectSelect" name="projectCountry" id="projectCountry" value={this.state.projectCountry} onChange={this.handleChange}>
                      <option value=""></option>
                      <option value="Afganistan">Afghanistan</option>
                      <option value="Albania">Albania</option>
                      <option value="Algeria">Algeria</option>
                      <option value="American Samoa">American Samoa</option>
                      <option value="Andorra">Andorra</option>
                      <option value="Angola">Angola</option>
                      <option value="Anguilla">Anguilla</option>
                      <option value="Antigua & Barbuda">Antigua & Barbuda</option>
                      <option value="Argentina">Argentina</option>
                      <option value="Armenia">Armenia</option>
                      <option value="Aruba">Aruba</option>
                      <option value="Australia">Australia</option>
                      <option value="Austria">Austria</option>
                      <option value="Azerbaijan">Azerbaijan</option>
                      <option value="Bahamas">Bahamas</option>
                      <option value="Bahrain">Bahrain</option>
                      <option value="Bangladesh">Bangladesh</option>
                      <option value="Barbados">Barbados</option>
                      <option value="Belarus">Belarus</option>
                      <option value="Belgium">Belgium</option>
                      <option value="Belize">Belize</option>
                      <option value="Benin">Benin</option>
                      <option value="Bermuda">Bermuda</option>
                      <option value="Bhutan">Bhutan</option>
                      <option value="Bolivia">Bolivia</option>
                      <option value="Bonaire">Bonaire</option>
                      <option value="Bosnia & Herzegovina">Bosnia & Herzegovina</option>
                      <option value="Botswana">Botswana</option>
                      <option value="Brazil">Brazil</option>
                      <option value="British Indian Ocean Ter">British Indian Ocean Ter</option>
                      <option value="Brunei">Brunei</option>
                      <option value="Bulgaria">Bulgaria</option>
                      <option value="Burkina Faso">Burkina Faso</option>
                      <option value="Burundi">Burundi</option>
                      <option value="Cambodia">Cambodia</option>
                      <option value="Cameroon">Cameroon</option>
                      <option value="Canada">Canada</option>
                      <option value="Canary Islands">Canary Islands</option>
                      <option value="Cape Verde">Cape Verde</option>
                      <option value="Cayman Islands">Cayman Islands</option>
                      <option value="Central African Republic">Central African Republic</option>
                      <option value="Chad">Chad</option>
                      <option value="Channel Islands">Channel Islands</option>
                      <option value="Chile">Chile</option>
                      <option value="China">China</option>
                      <option value="Christmas Island">Christmas Island</option>
                      <option value="Cocos Island">Cocos Island</option>
                      <option value="Colombia">Colombia</option>
                      <option value="Comoros">Comoros</option>
                      <option value="Congo">Congo</option>
                      <option value="Cook Islands">Cook Islands</option>
                      <option value="Costa Rica">Costa Rica</option>
                      <option value="Cote DIvoire">Cote DIvoire</option>
                      <option value="Croatia">Croatia</option>
                      <option value="Cuba">Cuba</option>
                      <option value="Curaco">Curacao</option>
                      <option value="Cyprus">Cyprus</option>
                      <option value="Czech Republic">Czech Republic</option>
                      <option value="Denmark">Denmark</option>
                      <option value="Djibouti">Djibouti</option>
                      <option value="Dominica">Dominica</option>
                      <option value="Dominican Republic">Dominican Republic</option>
                      <option value="East Timor">East Timor</option>
                      <option value="Ecuador">Ecuador</option>
                      <option value="Egypt">Egypt</option>
                      <option value="El Salvador">El Salvador</option>
                      <option value="Equatorial Guinea">Equatorial Guinea</option>
                      <option value="Eritrea">Eritrea</option>
                      <option value="Estonia">Estonia</option>
                      <option value="Ethiopia">Ethiopia</option>
                      <option value="Falkland Islands">Falkland Islands</option>
                      <option value="Faroe Islands">Faroe Islands</option>
                      <option value="Fiji">Fiji</option>
                      <option value="Finland">Finland</option>
                      <option value="France">France</option>
                      <option value="French Guiana">French Guiana</option>
                      <option value="French Polynesia">French Polynesia</option>
                      <option value="French Southern Ter">French Southern Ter</option>
                      <option value="Gabon">Gabon</option>
                      <option value="Gambia">Gambia</option>
                      <option value="Georgia">Georgia</option>
                      <option value="Germany">Germany</option>
                      <option value="Ghana">Ghana</option>
                      <option value="Gibraltar">Gibraltar</option>
                      <option value="Great Britain">Great Britain</option>
                      <option value="Greece">Greece</option>
                      <option value="Greenland">Greenland</option>
                      <option value="Grenada">Grenada</option>
                      <option value="Guadeloupe">Guadeloupe</option>
                      <option value="Guam">Guam</option>
                      <option value="Guatemala">Guatemala</option>
                      <option value="Guinea">Guinea</option>
                      <option value="Guyana">Guyana</option>
                      <option value="Haiti">Haiti</option>
                      <option value="Hawaii">Hawaii</option>
                      <option value="Honduras">Honduras</option>
                      <option value="Hong Kong">Hong Kong</option>
                      <option value="Hungary">Hungary</option>
                      <option value="Iceland">Iceland</option>
                      <option value="Indonesia">Indonesia</option>
                      <option value="India">India</option>
                      <option value="Iran">Iran</option>
                      <option value="Iraq">Iraq</option>
                      <option value="Ireland">Ireland</option>
                      <option value="Isle of Man">Isle of Man</option>
                      <option value="Israel">Israel</option>
                      <option value="Italy">Italy</option>
                      <option value="Jamaica">Jamaica</option>
                      <option value="Japan">Japan</option>
                      <option value="Jordan">Jordan</option>
                      <option value="Kazakhstan">Kazakhstan</option>
                      <option value="Kenya">Kenya</option>
                      <option value="Kiribati">Kiribati</option>
                      <option value="Korea North">Korea North</option>
                      <option value="Korea Sout">Korea South</option>
                      <option value="Kuwait">Kuwait</option>
                      <option value="Kyrgyzstan">Kyrgyzstan</option>
                      <option value="Laos">Laos</option>
                      <option value="Latvia">Latvia</option>
                      <option value="Lebanon">Lebanon</option>
                      <option value="Lesotho">Lesotho</option>
                      <option value="Liberia">Liberia</option>
                      <option value="Libya">Libya</option>
                      <option value="Liechtenstein">Liechtenstein</option>
                      <option value="Lithuania">Lithuania</option>
                      <option value="Luxembourg">Luxembourg</option>
                      <option value="Macau">Macau</option>
                      <option value="Macedonia">Macedonia</option>
                      <option value="Madagascar">Madagascar</option>
                      <option value="Malaysia">Malaysia</option>
                      <option value="Malawi">Malawi</option>
                      <option value="Maldives">Maldives</option>
                      <option value="Mali">Mali</option>
                      <option value="Malta">Malta</option>
                      <option value="Marshall Islands">Marshall Islands</option>
                      <option value="Martinique">Martinique</option>
                      <option value="Mauritania">Mauritania</option>
                      <option value="Mauritius">Mauritius</option>
                      <option value="Mayotte">Mayotte</option>
                      <option value="Mexico">Mexico</option>
                      <option value="Midway Islands">Midway Islands</option>
                      <option value="Moldova">Moldova</option>
                      <option value="Monaco">Monaco</option>
                      <option value="Mongolia">Mongolia</option>
                      <option value="Montserrat">Montserrat</option>
                      <option value="Morocco">Morocco</option>
                      <option value="Mozambique">Mozambique</option>
                      <option value="Myanmar">Myanmar</option>
                      <option value="Nambia">Nambia</option>
                      <option value="Nauru">Nauru</option>
                      <option value="Nepal">Nepal</option>
                      <option value="Netherland Antilles">Netherland Antilles</option>
                      <option value="Netherlands">Netherlands (Holland, Europe)</option>
                      <option value="Nevis">Nevis</option>
                      <option value="New Caledonia">New Caledonia</option>
                      <option value="New Zealand">New Zealand</option>
                      <option value="Nicaragua">Nicaragua</option>
                      <option value="Niger">Niger</option>
                      <option value="Nigeria">Nigeria</option>
                      <option value="Niue">Niue</option>
                      <option value="Norfolk Island">Norfolk Island</option>
                      <option value="Norway">Norway</option>
                      <option value="Oman">Oman</option>
                      <option value="Pakistan">Pakistan</option>
                      <option value="Palau Island">Palau Island</option>
                      <option value="Palestine">Palestine</option>
                      <option value="Panama">Panama</option>
                      <option value="Papua New Guinea">Papua New Guinea</option>
                      <option value="Paraguay">Paraguay</option>
                      <option value="Peru">Peru</option>
                      <option value="Phillipines">Philippines</option>
                      <option value="Pitcairn Island">Pitcairn Island</option>
                      <option value="Poland">Poland</option>
                      <option value="Portugal">Portugal</option>
                      <option value="Puerto Rico">Puerto Rico</option>
                      <option value="Qatar">Qatar</option>
                      <option value="Republic of Montenegro">Republic of Montenegro</option>
                      <option value="Republic of Serbia">Republic of Serbia</option>
                      <option value="Reunion">Reunion</option>
                      <option value="Romania">Romania</option>
                      <option value="Russia">Russia</option>
                      <option value="Rwanda">Rwanda</option>
                      <option value="St Barthelemy">St Barthelemy</option>
                      <option value="St Eustatius">St Eustatius</option>
                      <option value="St Helena">St Helena</option>
                      <option value="St Kitts-Nevis">St Kitts-Nevis</option>
                      <option value="St Lucia">St Lucia</option>
                      <option value="St Maarten">St Maarten</option>
                      <option value="St Pierre & Miquelon">St Pierre & Miquelon</option>
                      <option value="St Vincent & Grenadines">St Vincent & Grenadines</option>
                      <option value="Saipan">Saipan</option>
                      <option value="Samoa">Samoa</option>
                      <option value="Samoa American">Samoa American</option>
                      <option value="San Marino">San Marino</option>
                      <option value="Sao Tome & Principe">Sao Tome & Principe</option>
                      <option value="Saudi Arabia">Saudi Arabia</option>
                      <option value="Senegal">Senegal</option>
                      <option value="Seychelles">Seychelles</option>
                      <option value="Sierra Leone">Sierra Leone</option>
                      <option value="Singapore">Singapore</option>
                      <option value="Slovakia">Slovakia</option>
                      <option value="Slovenia">Slovenia</option>
                      <option value="Solomon Islands">Solomon Islands</option>
                      <option value="Somalia">Somalia</option>
                      <option value="South Africa">South Africa</option>
                      <option value="Spain">Spain</option>
                      <option value="Sri Lanka">Sri Lanka</option>
                      <option value="Sudan">Sudan</option>
                      <option value="Suriname">Suriname</option>
                      <option value="Swaziland">Swaziland</option>
                      <option value="Sweden">Sweden</option>
                      <option value="Switzerland">Switzerland</option>
                      <option value="Syria">Syria</option>
                      <option value="Tahiti">Tahiti</option>
                      <option value="Taiwan">Taiwan</option>
                      <option value="Tajikistan">Tajikistan</option>
                      <option value="Tanzania">Tanzania</option>
                      <option value="Thailand">Thailand</option>
                      <option value="Togo">Togo</option>
                      <option value="Tokelau">Tokelau</option>
                      <option value="Tonga">Tonga</option>
                      <option value="Trinidad & Tobago">Trinidad & Tobago</option>
                      <option value="Tunisia">Tunisia</option>
                      <option value="Turkey">Turkey</option>
                      <option value="Turkmenistan">Turkmenistan</option>
                      <option value="Turks & Caicos Is">Turks & Caicos Is</option>
                      <option value="Tuvalu">Tuvalu</option>
                      <option value="Uganda">Uganda</option>
                      <option value="United Kingdom">United Kingdom</option>
                      <option value="Ukraine">Ukraine</option>
                      <option value="United Arab Erimates">United Arab Emirates</option>
                      <option value="United States of America">United States of America</option>
                      <option value="Uraguay">Uruguay</option>
                      <option value="Uzbekistan">Uzbekistan</option>
                      <option value="Vanuatu">Vanuatu</option>
                      <option value="Vatican City State">Vatican City State</option>
                      <option value="Venezuela">Venezuela</option>
                      <option value="Vietnam">Vietnam</option>
                      <option value="Virgin Islands (Brit)">Virgin Islands (Brit)</option>
                      <option value="Virgin Islands (USA)">Virgin Islands (USA)</option>
                      <option value="Wake Island">Wake Island</option>
                      <option value="Wallis & Futana Is">Wallis & Futana Is</option>
                      <option value="Yemen">Yemen</option>
                      <option value="Zaire">Zaire</option>
                      <option value="Zambia">Zambia</option>
                      <option value="Zimbabwe">Zimbabwe</option>
                  </select>
                  <br/>
                  {this.state.projectCountry == "United States of America" ? 
                    <div>
                        <b>Project State:</b>
                        <br/>
                        <select className="projectSelect" id="projectState" name="projectState" value={this.state.projectState} onChange={this.handleChange}>
                            <option value=""> </option>
                            <option value="AL">Alabama</option>
                            <option value="AK">Alaska</option>
                            <option value="AZ">Arizona</option>
                            <option value="AR">Arkansas</option>
                            <option value="CA">California</option>
                            <option value="CO">Colorado</option>
                            <option value="CT">Connecticut</option>
                            <option value="DE">Delaware</option>
                            <option value="DC">District Of Columbia</option>
                            <option value="FL">Florida</option>
                            <option value="GA">Georgia</option>
                            <option value="HI">Hawaii</option>
                            <option value="ID">Idaho</option>
                            <option value="IL">Illinois</option>
                            <option value="IN">Indiana</option>
                            <option value="IA">Iowa</option>
                            <option value="KS">Kansas</option>
                            <option value="KY">Kentucky</option>
                            <option value="LA">Louisiana</option>
                            <option value="ME">Maine</option>
                            <option value="MD">Maryland</option>
                            <option value="MA">Massachusetts</option>
                            <option value="MI">Michigan</option>
                            <option value="MN">Minnesota</option>
                            <option value="MS">Mississippi</option>
                            <option value="MO">Missouri</option>
                            <option value="MT">Montana</option>
                            <option value="NE">Nebraska</option>
                            <option value="NV">Nevada</option>
                            <option value="NH">New Hampshire</option>
                            <option value="NJ">New Jersey</option>
                            <option value="NM">New Mexico</option>
                            <option value="NY">New York</option>
                            <option value="NC">North Carolina</option>
                            <option value="ND">North Dakota</option>
                            <option value="OH">Ohio</option>
                            <option value="OK">Oklahoma</option>
                            <option value="OR">Oregon</option>
                            <option value="PA">Pennsylvania</option>
                            <option value="RI">Rhode Island</option>
                            <option value="SC">South Carolina</option>
                            <option value="SD">South Dakota</option>
                            <option value="TN">Tennessee</option>
                            <option value="TX">Texas</option>
                            <option value="UT">Utah</option>
                            <option value="VT">Vermont</option>
                            <option value="VA">Virginia</option>
                            <option value="WA">Washington</option>
                            <option value="WV">West Virginia</option>
                            <option value="WI">Wisconsin</option>
                            <option value="WY">Wyoming</option>
                        </select>
                        <br/>
                    </div>
                    :
                    <div>
                        <b>Project State/Province/Region:</b>
                        <br/>
                        <input type="text" value={this.state.projectState} name="projectState" id="projectState" className="companyInput" placeholder="State/Province/Region" onChange={this.handleChange}/>
                        <br/>
                    </div>
                  }
                  <b>Project City/Town/Village:</b>
                  <br/>
                  <input type="text" placeholder="e.g. Lansing" className="companyInput" name="projectCity" id="projectCity" required="" onChange={this.handleChange} value={this.state.projectCity}/>
                  <br/>
                  <b>Project Start Date:</b>
                  <br/>
                  <DatePicker
                    selected={this.state.startDate}
                    onChange={this.handleStartDateChange}
                    name="startDate"
                    dateFormat="M/dd/yyy"
                    className="projectInputDate"
                    autoComplete="off"
                  />
                  <br/>
                  <b>Project End Date:</b>
                  <br/>
                  <DatePicker
                    selected={this.state.endDate}
                    onChange={this.handleEndDateChange}
                    name="endDate"
                    dateFormat="M/dd/yyy"
                    className="projectInputDate"
                  />
                  <br/>
                  {this.state.mappingNew.sort(function(a, b){if(a.sorting < b.sorting) return -1; if(a.sorting > b.sorting) return 1; if(a.sorting == b.sorting){if(a.name > b.name) return 1; if(a.name < b.name) return -1;}}).filter(featureService=> (featureService.feature_service_type_id != 8)).map((featureService, index) => 
                        (parent.context.userPermissions.includes("mapping:" + featureService.name + ":update") &&
                            <FeatureServiceWrapperKML key={featureService.feature_service_type_id} label={featureService.label} name={featureService.name} feature_service_type_id={featureService.feature_service_type_id} feature_layers={featureService.feature_layers} updateFeatureService={this.updateFeatureService} updateFeatureLayer={this.updateFeatureLayer} updateMappedAttributes={this.updateMappedAttributes} addFeatureLayer={this.addFeatureLayer} updateFeatureField={this.updateFeatureField} updateShapefile={this.updateShapefile} deleteLayer={this.deleteLayer} pathLayers={this.state.pathLayers} multiPathLayers={this.state.multiPathLayers} pointLayers={this.state.pointLayers} polygonLayers={this.state.polygonLayers}/>
                        ))
                    }
                  <EsriKMLMap features={this.state.features} mappingOriginal={this.state.mappingOriginal}/>
                  <button id="submitProjectBtn" className="submitProjectBtn" onClick={this.handleSubmit}>SUBMIT PROJECT</button>
                </div>
              );
          }else{
            return(
              <Route>
                <Redirect to="/projects" />
              </Route>
            );
          }
        }
    }
}

export default KMLProject2;